import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSwiperSlide = _resolveComponent("VueSwiperSlide")!
  const _component_VueSwiper = _resolveComponent("VueSwiper")!

  return (_openBlock(), _createBlock(_component_VueSwiper, {
    ref: "swiperComponent",
    class: "RcSwiper",
    options: _ctx.swiperOptions
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock(_component_VueSwiperSlide, { key: index }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "slide", { item: item })
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1)),
      _createElementVNode("div", {
        class: "swiper-button-prev",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.next()))
      }),
      _createElementVNode("div", {
        class: "swiper-button-next",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prev()))
      })
    ]),
    _: 3
  }, 8, ["options"]))
}